/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ትናንት",
        "-2": "ከትናንት ወዲያ",
        "0": "ዛሬ",
        "1": "ነገ",
        "2": "ከነገ ወዲያ",
        "future": {
          "one": "በ{0} ቀን ውስጥ",
          "other": "በ{0} ቀናት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ቀን በፊት",
          "other": "ከ{0} ቀናት በፊት"
        }
      },
      "day-narrow": {
        "-1": "ትላንትና",
        "-2": "ከትናንት ወዲያ",
        "0": "ዛሬ",
        "1": "ነገ",
        "2": "ከነገ ወዲያ",
        "future": {
          "one": "በ{0} ቀን ውስጥ",
          "other": "በ{0} ቀኖች ውስጥ"
        },
        "past": {
          "one": "ከ {0} ቀን በፊት",
          "other": "ከ{0} ቀኖች በፊት"
        }
      },
      "day-short": {
        "-1": "ትላንትና",
        "-2": "ከትናንት ወዲያ",
        "0": "ዛሬ",
        "1": "ነገ",
        "2": "ከነገ ወዲያ",
        "future": {
          "one": "በ{0} ቀን ውስጥ",
          "other": "በ{0} ቀኖች ውስጥ"
        },
        "past": {
          "one": "ከ {0} ቀን በፊት",
          "other": "ከ{0} ቀኖች በፊት"
        }
      },
      "hour": {
        "0": "ይህ ሰዓት",
        "future": {
          "one": "በ{0} ሰዓት ውስጥ",
          "other": "በ{0} ሰዓቶች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሰዓት በፊት",
          "other": "ከ{0} ሰዓቶች በፊት"
        }
      },
      "hour-narrow": {
        "0": "ይህ ሰዓት",
        "future": {
          "one": "በ{0} ሰዓት ውስጥ",
          "other": "በ{0} ሰዓቶች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሰዓት በፊት",
          "other": "ከ{0} ሰዓቶች በፊት"
        }
      },
      "hour-short": {
        "0": "ይህ ሰዓት",
        "future": {
          "one": "በ{0} ሰዓት ውስጥ",
          "other": "በ{0} ሰዓቶች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሰዓት በፊት",
          "other": "ከ{0} ሰዓቶች በፊት"
        }
      },
      "minute": {
        "0": "ይህ ደቂቃ",
        "future": {
          "one": "በ{0} ደቂቃ ውስጥ",
          "other": "በ{0} ደቂቃዎች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ደቂቃ በፊት",
          "other": "ከ{0} ደቂቃዎች በፊት"
        }
      },
      "minute-narrow": {
        "0": "ይህ ደቂቃ",
        "future": {
          "one": "በ{0} ደቂቃ ውስጥ",
          "other": "በ{0} ደቂቃዎች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ደቂቃ በፊት",
          "other": "ከ{0} ደቂቃዎች በፊት"
        }
      },
      "minute-short": {
        "0": "ይህ ደቂቃ",
        "future": {
          "one": "በ{0} ደቂቃ ውስጥ",
          "other": "በ{0} ደቂቃዎች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ደቂቃ በፊት",
          "other": "ከ{0} ደቂቃዎች በፊት"
        }
      },
      "month": {
        "-1": "ያለፈው ወር",
        "0": "በዚህ ወር",
        "1": "የሚቀጥለው ወር",
        "future": {
          "one": "በ{0} ወር ውስጥ",
          "other": "በ{0} ወራት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ወር በፊት",
          "other": "ከ{0} ወራት በፊት"
        }
      },
      "month-narrow": {
        "-1": "ያለፈው ወር",
        "0": "በዚህ ወር",
        "1": "የሚቀጥለው ወር",
        "future": {
          "one": "በ{0} ወራት ውስጥ",
          "other": "በ{0} ወራት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ወራት በፊት",
          "other": "ከ{0} ወራት በፊት"
        }
      },
      "month-short": {
        "-1": "ያለፈው ወር",
        "0": "በዚህ ወር",
        "1": "የሚቀጥለው ወር",
        "future": {
          "one": "በ{0} ወራት ውስጥ",
          "other": "በ{0} ወራት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ወራት በፊት",
          "other": "ከ{0} ወራት በፊት"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "የመጨረሻው ሩብ",
        "0": "ይህ ሩብ",
        "1": "የሚቀጥለው ሩብ",
        "future": {
          "one": "+{0} ሩብ",
          "other": "+{0} ሩብ"
        },
        "past": {
          "one": "{0} ሩብ በፊት",
          "other": "{0} ሩብ በፊት"
        }
      },
      "quarter-narrow": {
        "-1": "የመጨረሻው ሩብ",
        "0": "ይህ ሩብ",
        "1": "የሚቀጥለው ሩብ",
        "future": {
          "one": "+{0} ሩብ",
          "other": "+{0} ሩብ"
        },
        "past": {
          "one": "{0} ሩብ በፊት",
          "other": "{0} ሩብ በፊት"
        }
      },
      "quarter-short": {
        "-1": "የመጨረሻው ሩብ",
        "0": "ይህ ሩብ",
        "1": "የሚቀጥለው ሩብ",
        "future": {
          "one": "+{0} ሩብ",
          "other": "+{0} ሩብ"
        },
        "past": {
          "one": "{0} ሩብ በፊት",
          "other": "{0} ሩብ በፊት"
        }
      },
      "second": {
        "0": "አሁን",
        "future": {
          "one": "በ{0} ሰከንድ ውስጥ",
          "other": "በ{0} ሰከንዶች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሰከንድ በፊት",
          "other": "ከ{0} ሰከንዶች በፊት"
        }
      },
      "second-narrow": {
        "0": "አሁን",
        "future": {
          "one": "በ{0} ሰከንድ ውስጥ",
          "other": "በ{0} ሰከንዶች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሰከንድ በፊት",
          "other": "ከ{0} ሰከንዶች በፊት"
        }
      },
      "second-short": {
        "0": "አሁን",
        "future": {
          "one": "በ{0} ሰከንድ ውስጥ",
          "other": "በ{0} ሰከንዶች ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሰከንድ በፊት",
          "other": "ከ{0} ሰከንዶች በፊት"
        }
      },
      "week": {
        "-1": "ያለፈው ሳምንት",
        "0": "በዚህ ሳምንት",
        "1": "የሚቀጥለው ሳምንት",
        "future": {
          "one": "በ{0} ሳምንት ውስጥ",
          "other": "በ{0} ሳምንታት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሳምንት በፊት",
          "other": "ከ{0} ሳምንታት በፊት"
        }
      },
      "week-narrow": {
        "-1": "ባለፈው ሳምንት",
        "0": "በዚህ ሣምንት",
        "1": "የሚቀጥለው ሳምንት",
        "future": {
          "one": "በ{0} ሳምንታት ውስጥ",
          "other": "በ{0} ሳምንታት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሳምንታት በፊት",
          "other": "ከ{0} ሳምንታት በፊት"
        }
      },
      "week-short": {
        "-1": "ባለፈው ሳምንት",
        "0": "በዚህ ሣምንት",
        "1": "የሚቀጥለው ሳምንት",
        "future": {
          "one": "በ{0} ሳምንታት ውስጥ",
          "other": "በ{0} ሳምንታት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ሳምንታት በፊት",
          "other": "ከ{0} ሳምንታት በፊት"
        }
      },
      "year": {
        "-1": "ያለፈው ዓመት",
        "0": "በዚህ ዓመት",
        "1": "የሚቀጥለው ዓመት",
        "future": {
          "one": "በ{0} ዓመታት ውስጥ",
          "other": "በ{0} ዓመታት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ዓመት በፊት",
          "other": "ከ{0} ዓመታት በፊት"
        }
      },
      "year-narrow": {
        "-1": "ያለፈው ዓመት",
        "0": "በዚህ ዓመት",
        "1": "የሚቀጥለው ዓመት",
        "future": {
          "one": "በ{0} ዓመታት ውስጥ",
          "other": "በ{0} ዓመታት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ዓመታት በፊት",
          "other": "ከ{0} ዓመታት በፊት"
        }
      },
      "year-short": {
        "-1": "ያለፈው ዓመት",
        "0": "በዚህ ዓመት",
        "1": "የሚቀጥለው ዓመት",
        "future": {
          "one": "በ{0} ዓመታት ውስጥ",
          "other": "በ{0} ዓመታት ውስጥ"
        },
        "past": {
          "one": "ከ{0} ዓመታት በፊት",
          "other": "ከ{0} ዓመታት በፊት"
        }
      }
    },
    "locale": "am"
  });
}